import styled from 'styled-components';

export const ReviewContainer = styled.article`
  padding: 25px 0 25px 0;
  width: 100%;
`;

export const ReviewBody = styled.p`
  margin: 0;
  padding: 0;
  
  font-size: 16px;
  color: ${({ theme }) => theme.black};
`;

export const ReviewHeaderWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  
  & + ${ReviewBody} {
    margin-top: 15px;
  }
`;

export const ReviewDate = styled.div`
  font-size: 12px;
  color: ${({ theme }) => theme.black};
`;

export const ReviewAuthor = styled.h3`
  margin: 0;
  padding: 0;
  
  font-size: 16px;
  font-weight: 700;
  color: ${({ theme }) => theme.black};
`;

export const ReviewInfo = styled.div``;
